(function (app) {
    app.constant('chartColors', ['#4d8ffa', '#6fbf91', '#37a184', '#e86666', '#f7d24a', '#3a5687', '#915678', '#f08b56', '#76829a', '#5a576d', '#76e3a6', '#bd938a', '#faf2a4', '#437077', '#5cbbc1', '#fc9d9d', '#ffc954', '#fd59a0', '#c0fafe', '#88c1ff']);

    app.config([
        "ChartJsProvider", "chartColors", function (ChartJsProvider, chartColors) {
            function generateColors() {
                var result = chartColors.map(function (color) {
                    return {
                        backgroundColor: color,
                        hoverBackgroundColor: color,
                        pointBackgroundColor: color,
                        pointHoverBackgroundColor: color,
                        borderColor: color,
                        hoverBorderColor: color,
                        pointBorderColor: color,
                        pointHoverBorderColor: color,
                    }
                });

                return result;
            }

            ChartJsProvider.setOptions({
                global: {
                    colors: generateColors(),
                    labels: {
                        boxWidth: 12,
                        fontColor: '#5C5C69',
                        fontSize: 12,
                    },
                    tooltips: {
                        titleFontFamily: "'rawline', sans-serif",
                        titleFontSize: 14,
                        titleFontStyle: 'medium'
                    },
                    defaultFontColor: '#5C5C69',
                    defaultFontFamily: "'rawline', sans-serif"
                },
                bar: {
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            scaleLabel: {
                                fontColor: '#616161'
                            },
                            ticks: {
                                beginAtZero: true,
                                fontColor: '#333',
                                padding: 10,
                                lineHeight: 2
                            },
                            gridLines: {
                                zeroLineColor: '#E6E6E6',
                                color: '#E6E6E6',
                                tickMarkLength: 0
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontColor: '#333',
                                padding: 10,
                                lineHeight: 2
                            },
                            gridLines: {
                                zeroLineColor: '#E6E6E6',
                                color: '#E6E6E6',
                                tickMarkLength: 0
                            }
                        }]
                    }
                },
                horizontalBar: {
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            scaleLabel: {
                                fontColor: '#616161'
                            },
                            ticks: {
                                beginAtZero: true,
                                fontColor: '#333',
                                padding: 10,
                                lineHeight: 2
                            },
                            gridLines: {
                                zeroLineColor: '#E6E6E6',
                                color: '#E6E6E6',
                                tickMarkLength: 0
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontColor: '#333',
                                padding: 10,
                                lineHeight: 2
                            },
                            gridLines: {
                                zeroLineColor: '#E6E6E6',
                                color: '#E6E6E6',
                                tickMarkLength: 0
                            }
                        }]
                    }
                },
                pie: {
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    }
                },
                doughnut: {
                    cutoutPercentage: 85,
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    }
                }
            });
        }]);
})(window.app);

//Chart.js Documentation: https://www.chartjs.org/docs/latest/
//Angular-chart.js Documentation: https://github.com/jtblin/angular-chart.js